import ReactGA from 'react-ga4';

import { GaEventOptions } from './types';

function sendEvent(event: GaEventOptions) {
  if (event) ReactGA.event(event);
}

export default sendEvent;
